<template>
  <v-dialog
    v-model="reopenDialog"
    persistent
    scrollable
    max-width="500"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-if="$store.getters.isInternal"
        small
        v-bind="attrs"
        v-on="on"
        @click="reopenDialogInit"
      >
        <v-icon dark>
          mdi-undo-variant
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="title white--text secondary">
        {{ $t('supportTicketDialogReopen.title') }}
      </v-card-title>
      <v-card-text>
        <Loading :loading="!loaded" />

        <v-container
          v-if="loaded && reopenModel"
          fluid
        >
          <v-row>
            <v-col>
              <v-textarea
                v-model="reopenModel.data.comment"
                :label="$t('common.comment')"
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          color="primary"
          @click="reopenDialogCancel"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="secondary"
          :loading="saving"
          @click="reopenDialogSave"
        >
          {{ $t('common.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from '@/components/Loading'

export default {
  name: "SupportTicketDialogReopen",
  components: {
    Loading
  },
  props: {},
  data() {
    return {
      reopenModel: Object,
      reopenDialog: false,
      loaded: false,
      saving: false
    };
  },
  methods: {
    reopenDialogInit: function () {
      this.reopenDialog = true;

      this.$api.get(`supportticket/reopen/${this.$route.params.id}`).then((response) => {
        this.reopenModel = response.data;
        this.loaded = true;
      });
    },
    reopenDialogSave: function () {
      this.saving = true;

      this.$api.put(`supportticket/reopen/${this.$route.params.id}`, this.reopenModel.data).then((response) => {
        if (response.data.success) {
          this.saving = false;
          this.reopenDialog = false;
          this.$emit("saved");
        } else {
          //TODO: Error handle...
        }
      });
    },
    reopenDialogCancel: function () {
      this.reopenModel = null;
      this.reopenDialog = false;
      this.loaded = false;
    },
  },
};
</script>